const TiddlyMapView = () => null

export default TiddlyMapView